import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './error-pages.css';

export function ServerError(): JSX.Element {
  useEffect(() => {
    document.title = '500 - Server Error - Kibo Hub';
  }, []);

  const handleRefresh = (): void => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-content">
        <h1 className="error-code">500</h1>
        <h2 className="error-title">Server Error</h2>
        <p className="error-description">
          Something went wrong on our end. Please try again later or contact support
          if the problem persists.
        </p>
        <div className="error-actions">
          <button onClick={handleRefresh} className="btn btn-primary">
            Refresh Page
          </button>
          <Link to="/" className="btn btn-outline">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
